import { InterfaceIcon, getSvgIcon } from '@helpers/icons';
import { clamp } from '@helpers/utils';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { FocusRing } from '@react-aria/focus';
import { renderLogo } from '@stories/Widgets/Global/Header/Header';
import * as React from 'react';
import S from './RegionSelector.styles';
const RegionSelector = (props) => {
    const [open, setOpen] = React.useState(false);
    const containerRef = useOutsideClick(() => setOpen(false));
    const buttonRef = React.useRef(null);
    const itemsRef = React.useRef([]);
    if (!props.regions || props.regions.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: containerRef },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Button, { ref: buttonRef, "aria-haspopup": "menu", "aria-expanded": open, "aria-controls": `${props.idPrefix ?? ''}-region-options`, onClick: () => setOpen(!open), onKeyDown: (event) => {
                    switch (event.key) {
                        case 'ArrowDown':
                            if (!open) {
                                setOpen(true);
                            }
                            focusRegion(0);
                            break;
                        case 'Escape':
                            setOpen(false);
                            break;
                    }
                } },
                getSvgIcon(InterfaceIcon.Language),
                " ",
                props.label,
                " ",
                getSvgIcon(InterfaceIcon.Chevron))),
        React.createElement(S.Regions, { id: `${props.idPrefix ?? ''}-region-options`, role: "menu" }, props.regions.map((region, i) => (React.createElement("li", { key: `${props.idPrefix ?? ''}-${region.site}`, role: "none" },
            React.createElement(S.Region, { ref: (el) => (itemsRef.current[i] = el), tabIndex: open ? undefined : -1, role: region.languages && region.languages.length > 0 ? 'menu' : 'menuitem', onKeyDown: (event) => {
                    const nextIndex = i === props.regions.length - 1 ? 0 : clamp(i + 1, props.regions.length - 1);
                    const prevIndex = i === 0 ? props.regions.length - 1 : clamp(i - 1, props.regions.length - 1);
                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault();
                            event.stopPropagation();
                            focusRegion(nextIndex);
                            break;
                        case 'ArrowUp':
                            event.preventDefault();
                            event.stopPropagation();
                            focusRegion(prevIndex);
                            break;
                        case 'Escape':
                            setOpen(false);
                            buttonRef.current?.focus();
                            break;
                        default:
                            break;
                    }
                }, ...(region.languages && region.languages.length > 0
                    ? { as: 'span' }
                    : { href: region.url }) },
                renderLogo(region.site),
                React.createElement("span", null,
                    region.text,
                    region.languages && region.languages.length > 0 && (React.createElement(S.LanguageLinks, { role: "none" }, region.languages.map((language, j) => (React.createElement(S.Language, { key: `${props.idPrefix ?? ''}-${region.site}-${j}`, role: "menuitem", href: language.url, onKeyDown: (event) => {
                            const nextIndex = i === props.regions.length - 1
                                ? 0
                                : clamp(i + 1, props.regions.length - 1);
                            const nextLanguageIndex = j === region.languages.length - 1
                                ? 0
                                : clamp(j + 1, region.languages.length);
                            const prevIndex = i === 0
                                ? props.regions.length - 1
                                : clamp(i - 1, props.regions.length - 1);
                            const prevLanguageIndex = j === 0
                                ? region.languages.length
                                : clamp(j - 1, region.languages.length);
                            switch (event.key) {
                                case 'ArrowDown':
                                    event.preventDefault();
                                    event.stopPropagation();
                                    focusRegion(nextIndex);
                                    break;
                                case 'ArrowUp':
                                    event.preventDefault();
                                    event.stopPropagation();
                                    focusRegion(prevIndex);
                                    break;
                                case 'ArrowRight':
                                    event.preventDefault();
                                    event.stopPropagation();
                                    // prettier-ignore
                                    itemsRef.current[i]?.querySelectorAll('a')[nextLanguageIndex]?.focus();
                                    break;
                                case 'ArrowLeft':
                                    event.preventDefault();
                                    event.stopPropagation();
                                    // prettier-ignore
                                    itemsRef.current[i]?.querySelectorAll('a')[prevLanguageIndex]?.focus();
                                    break;
                                case 'Escape':
                                    setOpen(false);
                                    buttonRef.current?.focus();
                                    break;
                                default:
                                    break;
                            }
                        }, "aria-label": `${region.text}: ${language.text}`, tabIndex: open ? undefined : -1 }, language.text)))))))))))));
    function focusRegion(index) {
        if (props.regions[index].languages && props.regions[index].languages.length > 0) {
            itemsRef.current[index]?.querySelectorAll('a')[0]?.focus();
        }
        else {
            itemsRef.current[index]?.focus();
        }
    }
};
export default RegionSelector;
